(() => {
  const publish = (name, data) => {
    const payload = Object.assign(
      {
        page_path: window.location.pathname,
        page_title: document.title,
        locale: document.documentElement.lang || '',
      },
      data || {}
    );

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch (error) {
      /* keep storefront usable if analytics is blocked */
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));

    if (typeof window.gtag === 'function') {
      if (name === 'moz_product_view' && payload.product_id) {
        window.gtag('event', 'view_item', {
          currency: payload.currency,
          value: payload.value,
          items: [{ item_id: payload.product_id, item_name: payload.product_handle, price: payload.value }],
        });
      } else if (name === 'moz_add_to_cart') {
        window.gtag('event', 'add_to_cart', {
          currency: payload.currency,
          value: payload.value,
          items: [{ item_id: payload.product_id, item_name: payload.product_handle, price: payload.value }],
        });
      } else if (name === 'moz_preview_click') {
        window.gtag('event', 'preview_click', { link_url: payload.href || '', event_label: payload.label || '' });
      }
    }
  };

  const onReady = () => {
    const template = document.body ? document.body.getAttribute('data-template') || '' : '';
    publish('moz_page_view', { template });

    if (template.indexOf('index') !== -1) publish('moz_home_view', { template });
    if (template.indexOf('product') !== -1) {
      const productEl = document.querySelector('[data-moz-product-handle]');
      const product = productEl
        ? {
            product_handle: productEl.getAttribute('data-moz-product-handle') || '',
            product_id: productEl.getAttribute('data-moz-product-id') || '',
            variant_id: productEl.getAttribute('data-moz-variant-id') || '',
            value: Number(productEl.getAttribute('data-moz-price') || 0),
            currency: productEl.getAttribute('data-moz-currency') || '',
          }
        : {};
      publish('moz_product_view', Object.assign({ template }, product));
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form || !form.closest || !form.closest('product-form')) return;
    const productEl = document.querySelector('[data-moz-product-handle]');
    publish('moz_add_to_cart', {
      product_handle: productEl ? productEl.getAttribute('data-moz-product-handle') || '' : '',
      product_id: productEl ? productEl.getAttribute('data-moz-product-id') || '' : '',
      variant_id: productEl ? productEl.getAttribute('data-moz-variant-id') || '' : '',
      value: productEl ? Number(productEl.getAttribute('data-moz-price') || 0) : 0,
      currency: productEl ? productEl.getAttribute('data-moz-currency') || '' : '',
    });
  });

  document.addEventListener('click', (event) => {
    const marked = event.target.closest('[data-moz-event]');
    if (marked) {
      publish(marked.getAttribute('data-moz-event'), {
        label: marked.getAttribute('data-moz-label') || (marked.textContent || '').trim().slice(0, 80),
        href: marked.getAttribute('href') || '',
      });
      return;
    }

    const previewLink = event.target.closest('a[href*="mozabrick.com"][href*="/upload"]');
    if (previewLink) {
      publish('moz_preview_click', {
        label: (previewLink.textContent || '').trim().slice(0, 80),
        href: previewLink.getAttribute('href') || '',
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
